import React from "react";
import NavBar from "./NavBar";
import Patent from "./Patent";

const Main_Patent = () => {
  return (
    <>
      <NavBar />
      <Patent />
    </>
  );
};

export default Main_Patent;
